/*
 * Copyright (c) 2023 Bolmate B.V.
 */
import './style/invoicePreview.scss';

import React, {PureComponent} from 'react';
import {CustomAppEvent, WithBackground, WithEvents, CloseButton} from '@dvrd/dvr-controls';
import classNames from 'classnames';
import {sendGaEvent, sendGaPageView} from "../../../util/analytics";

interface State {
    data: string;
}

export default class InvoicePreview extends PureComponent<any, State> {
    private readonly events: CustomAppEvent[];

    constructor(props: any) {
        super(props);
        this.events = [{eventName: 'onInvoicePreview', handler: this.onActivate}];
        this.state = {
            data: '',
        };
    }

    onActivate = (data: string) => {
        sendGaPageView('/factuur-preview');
        this.setState({data});
    };

    onClose = () => {
        sendGaEvent('Click', 'Factuur preview', 'Sluiten')
        const {data} = this.state;
        URL.revokeObjectURL(data);
        this.setState({data: ''});
    };

    render = () => {
        const {data} = this.state, isMac = /Mac/i.test(navigator.platform);
        return (
            <WithEvents events={this.events}>
                <WithBackground active={data.length > 0} onClose={this.onClose}>
                    <div className='pdf-preview-container'>
                        <div className={classNames('close-container', isMac && 'left')}>
                            <CloseButton onClick={this.onClose} className='close-preview'/>
                        </div>
                        <object data={data} type='application/pdf' style={{width: '100%', height: '100%'}}>
                            <embed src={data} type='application/pdf'/>
                        </object>
                    </div>
                </WithBackground>
            </WithEvents>
        )
    }
}